import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useTranslation, LanguageSwitcher } from '../i18n';
import { MapPin, Package, Send, LogOut, ChevronRight, Box, History } from 'lucide-react';

export default function Home() {
  const { user, logout } = useAuth();
  const [searchParams] = useSearchParams();
  
  useEffect(() => {
    const device = searchParams.get('device');
    const action = searchParams.get('action');
    if (device && action === 'delivery') {
      navigate(`/send?device=${device}`);
    } else if (device && action === 'pickup') {
      navigate(`/pickup?device=${device}`);
    }
  }, [searchParams]);
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div style={s.page}>
      <header style={s.header}>
        <div style={s.brand}>
          <img src="/damitove-logo.png" alt="Damitove" style={{height: 36, width: 'auto'}} />
          <span style={s.brandName}>Dami<span style={{color:'#8BC63E'}}>tove</span></span>
        </div>
        <div style={s.headerRight}>
          <div
            onClick={() => navigate('/profile')}
            style={{
              width: 38, height: 38, borderRadius: '50%',
              background: 'linear-gradient(135deg, #8BC63E, #00b4d8)',
              color: '#07080c',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontSize: 14, fontWeight: 800, cursor: 'pointer',
            }}
            title="Profile"
          >
            {(user?.first_name?.[0] || user?.full_name?.[0] || user?.email?.[0] || 'U').toUpperCase()}
          </div>
          <LanguageSwitcher style={{ background: '#0f1117', border: '1px solid #252733', color: '#8789a0' }} />
          <span style={{...s.userName, cursor:'pointer'}} onClick={() => navigate('/profile')}>{user?.full_name || user?.first_name}</span>
          <span style={s.logoutBtn} onClick={logout}><LogOut size={14} /> {t('nav.logout')}</span>
        </div>
      </header>

      <div style={s.hero}>
        <h1 style={s.heroTitle}>{t('parcel.sendTitle')} & {t('parcel.pickupTitle')}</h1>
        <p style={s.heroSub}>{t('common.language') === 'ენა' ? 'სმარტ ლოკერით მიწოდება მარტივად' : 'Smart locker delivery made simple'}</p>
      </div>

      <div style={s.grid}>
        <div style={s.card} onClick={() => navigate('/send')}>
          <div style={{...s.cardIcon, background: 'rgba(139,198,62,0.1)'}}><Send size={24} color="#8BC63E" /></div>
          <h3 style={s.cardTitle}>{t('parcel.sendTitle')}</h3>
          <p style={s.cardDesc}>{t('parcel.codeWillBeSent')}</p>
          <div style={s.cardAction}>{t('common.next')} <ChevronRight size={16} /></div>
        </div>

        <div style={s.card} onClick={() => navigate('/pickup')}>
          <div style={{...s.cardIcon, background: 'rgba(77,144,254,0.1)'}}><Package size={24} color="#4d90fe" /></div>
          <h3 style={s.cardTitle}>{t('parcel.pickupTitle')}</h3>
          <p style={s.cardDesc}>{t('parcel.enterPickupCode')}</p>
          <div style={{...s.cardAction, color: '#4d90fe'}}>{t('parcel.pickupCode')} <ChevronRight size={16} /></div>
        </div>

        <div style={s.card} onClick={() => navigate('/orders')}>
          <div style={{...s.cardIcon, background: 'rgba(167,139,250,0.1)'}}><History size={24} color="#a78bfa" /></div>
          <h3 style={s.cardTitle}>{t('orders.title')}</h3>
          <p style={s.cardDesc}>{t('orders.trackOrder')}</p>
          <div style={{...s.cardAction, color: '#a78bfa'}}>{t('orders.details')} <ChevronRight size={16} /></div>
        </div>
      </div>
    </div>
  );
}

const s = {
  page: { minHeight: '100vh', background: '#07080c', color: '#e4e5ed' },
  header: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '16px 24px', borderBottom: '1px solid #252733' },
  brand: { display: 'flex', alignItems: 'center', gap: 10 },
  logo: { width: 34, height: 34, background: 'linear-gradient(135deg, #8BC63E, #00b4d8)', borderRadius: 10, display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 800, fontSize: 16, color: '#07080c' },
  brandName: { fontWeight: 700, fontSize: 18, color: '#e4e5ed', letterSpacing: -0.3 },
  headerRight: { display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' },
  userName: { fontSize: 13, color: '#8789a0' },
  logoutBtn: { display: 'flex', alignItems: 'center', gap: 4, fontSize: 12, color: '#8a8da4', cursor: 'pointer' },
  hero: { textAlign: 'center', padding: '32px 20px 24px' },
  heroTitle: { fontSize: 26, fontWeight: 800, letterSpacing: -0.5, marginBottom: 8 },
  heroSub: { fontSize: 16, color: '#8789a0' },
  grid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: 12, maxWidth: 960, margin: '0 auto', padding: '0 16px 40px' },
  card: { background: '#0f1117', border: '1px solid #252733', borderRadius: 16, padding: 22, cursor: 'pointer', transition: 'border-color 0.2s' },
  cardIcon: { width: 48, height: 48, borderRadius: 12, display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 16 },
  cardTitle: { fontSize: 18, fontWeight: 700, marginBottom: 8 },
  cardDesc: { fontSize: 14, color: '#8789a0', lineHeight: 1.5, marginBottom: 16 },
  cardAction: { display: 'flex', alignItems: 'center', gap: 4, fontSize: 13, fontWeight: 600, color: '#8BC63E' },
};
